<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f2f5;"
       ref="contentData">
    <pcHeaders></pcHeaders>
    <div class="imgBg"><img src="@/assets/images/zcimg/gywm.png"
           alt=""
           style="width: 100%; height:300px" /></div>

    <div style="background: #f0f2f5;padding-bottom: 127px;">
      <div style="display: flex;justify-content: center;">
      <div class="gywm">
        <div style="margin-right: 40px;">
          <div class="gy1">关于我们</div>
          <div class="gy2">为深入实施人才强国战略，加强全国专业技术人才队伍建设，促进专业技术人才能力素质提升，根据国 家“十四五”规划和2035年远景目标纲要，人社部、财政部等决定2021年至2030年继续实施新一轮专业技术人才知识更新工程。 航程科技充分发挥在技术、资源和服务方面的优势，与各级继续教育基地紧密合作，整合国内外优质教
            育资源，共同打造“现代专技继续教育网”公共服务平台，致力于为专业技术人才培养和队伍建设提供全方位、高质量的服务，积极支持国家“专业技术人才知识更新工程”的实施，为推动我国专业技术人才队伍的发展和壮大贡献力量。</div>
        </div>
        <div>
          <img src="../../assets/images/zcimg/gy1.png"
               alt="">
        </div>
      </div>

    </div>
    <div style="display: flex;justify-content: center;">
      <div class="gyForm">
        <div class="gy1">商务合作</div>
        <div class="gy23">
          <div class="i1">
            <img src="../../assets/images/zcimg/gy2.png" alt="">
            <div class="gt1">
              集平台、课程、市场与服务进行共享与合作
            </div>
          </div>
          <div class="gf">
            <div style="display: flex;justify-content: space-between;">
              <div>
                <div style="font-size: 18px;">您的姓名：</div>
                <el-input v-model="form.realName" style="margin-top: 16px;width: 320px;" placeholder="请输入您的姓名"></el-input>
              </div>
              <div style="margin-left: 100px;">
                <div style="font-size: 18px;" >您的联系方式：</div>
                <el-input v-model="form.phone" style="margin-top: 16px;width: 320px;" placeholder="请输入您的联系方式"></el-input>
              </div>
            </div>

            <div style="margin-top: 40px;">
              <div style="font-size: 18px;">备注（意向）：</div>
              <el-input
                style="width: 741px;margin-top: 12px;"
                type="textarea"
                v-model="form.remark"
                placeholder="请输入您的意向"
                :rows="5"
                >
              </el-input>
            </div>

            <div class="gbtn" @click="toBusinessCooperation">确认提交</div>
          </div>
        </div>
         
      </div>
    
    </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import zxdy from './component/zxdy.vue';
import { toBusinessCooperation } from '../../api/tzgg'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    zxdy
  },
  metaInfo() {
    return {
      title: this.title + '-中财专技',
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ],
      
    };
  },
  data() {
    // 这里存放数据
    return {
      form:{
        realName:'',
        phone:'',
        remark:'',
      },
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toBusinessCooperation() {
      if (this.form.realName.trim() == '') {
        this.$message('姓名不可为空！')
        return false
      }
      if (this.form.phone.trim() == '') {
        this.$message('手机号不可为空！')
        return false
      }
      if (this.form.remark.trim() == '') {
        this.$message('备注（意向）不可为空！')
        return false
      }
      toBusinessCooperation(this.form).then(res => {
        console.log(res);
        if (res.data.code == '200') {
          this.$message.success('提交成功！请耐心等待客服回复')
        }
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.gywm {
  margin-top: 40px;
  width: 1400px;
  background: #ffffff;
  padding: 26px 30px 26px 30px;
  display: flex;
  .gy1 {
    font-weight: bold;
    font-size: 28px;
    color: #333333;
  }
  .gy2 {
    margin-top: 20px;
    width: 849px;
    height: 174px;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
}
.gyForm {
  margin-top: 25px;
  width: 1400px;
  background: #ffffff;
  padding: 26px 0 77px 31px;
  .gy1 {
    font-weight: bold;
    font-size: 28px;
    color: #333333;
  }
  .gy23 {
    display: flex;
    margin-top: 20px;
    .i1 {
      position: relative;
      .gt1 {
        position: absolute;
        top: 31px;
        left: 20px;
        width: 209px;
        height: 66px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .gf {
      margin-left: 30px;
    }
    .gbtn {
      margin-top: 50px;
      width: 150px;
      height: 48px;
      background: #217CBE;
      border-radius: 24px 24px 24px 24px;
      cursor: pointer;
      text-align: center;
      line-height: 48px;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
}
.group_1 {
  width: 100%;
  height: 250px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title_1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  letter-spacing: 2px;
}
.text_1 {
  margin-top: 30px;
  width: 1200px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  letter-spacing: 1px;
}
.group_2 {
  width: 100%;
  height: 736px;
  background-color: #f4f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .box_1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .title_2 {
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 28px;
    color: #333333;
    letter-spacing: 2px;
  }
  .title_3 {
    margin-top: 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    letter-spacing: 1px;
  }
  .box_2 {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .step {
      margin-right: 21px;
      width: 335px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      padding: 31px 43px;
      .btn_1 {
        width: 88px;
        height: 32px;
        background: rgba(64, 118, 246, 0.15);
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 32px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #4076f6;
        letter-spacing: 1px;
      }
      .text_2 {
        margin-top: 10px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        letter-spacing: 2px;
      }
      .text_3 {
        margin-top: 16px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        letter-spacing: 1px;
      }
    }
  }
  .box_3 {
    width: 1430px;
    margin-top: 24px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .download_1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 691px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      .text_5 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #4076f6;
        letter-spacing: 2px;
      }
      .text_6 {
        margin-top: 16px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        letter-spacing: 1px;
        width: 590px;
      }
      .btn_2 {
        cursor: pointer;
        margin-top: 24px;
        width: 180px;
        height: 46px;
        background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
        border-radius: 6px 6px 6px 6px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: center;
        line-height: 46px;
      }
    }
    .download_2 {
      padding: 24px 21px;
      width: 601px;
      height: 230px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .text_4 {
        margin-top: 23px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 20px;
        color: #c4c4c4;
        letter-spacing: 2px;
      }
    }
  }
}
.group_3 {
  width: 100%;
  height: 970px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title_4 {
    margin-top: 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 2px;
  }
  .title_5 {
    margin-top: 16px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    letter-spacing: 1px;
  }
  .box_4,
  .box_6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .box_5 {
    display: flex;
    margin-top: 72px;

    background: #ffffff;

    .box_9 {
      width: 564px;
      height: 374px;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 20px 20px 20px 20px;
      padding: 51px 39px 0 24px;
      .info {
        display: flex;

        flex-wrap: wrap;
        .text_7 {
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          letter-spacing: 1px;
        }
        .cicle {
          margin-right: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);

          .cicle_1 {
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #ffffff;
            border-radius: 50%;
          }
        }
      }
    }
    .box_10 {
      margin-left: 92px;
      width: 564px;
      height: 374px;
      padding-top: 92px;
      .content {
        margin-bottom: 20px;
        width: 564px;
        display: flex;
        align-items: center;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        .clicle_3 {
          margin-right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          background: #5674e6;
          border-radius: 50%;
          border: 1px solid #5674e6;
        }
      }
    }
  }
  .box_6 {
    margin-top: 90px;
  }
  .box_7 {
    display: flex;
    margin-top: 50px;
    .box_11 {
      margin-right: 55px;
      padding: 25px 0 0 110px;
      display: flex;
      width: 430px;
      height: 100px;
      background: #ffffff;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px 12px 12px 12px;
      .text_11 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 1px;
      }
      .text_12 {
        margin-top: 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        letter-spacing: 1px;
      }
    }
  }
}
.group_4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 140px;
  padding-top: 40px;
  background: #f4f6fa;
  .box_8 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title_4 {
      margin-top: 10px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      letter-spacing: 2px;
    }
    .title_5 {
      margin-top: 16px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      letter-spacing: 1px;
    }
  }
}
</style>
